import Component from '@glimmer/component';
import { service } from '@ember/service';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { dropTask, task } from 'ember-concurrency';

/**
 * @param {Function}    onClick
 * @param {Object}      response
 */
export default class FlashMessageRoomsDiscountComponent extends Component {
  @service currentAdmin;
  @service flashMessages;
  @service metrics;
  @service salesforceLeads;

  get message() {
    if (this.args.response.hasSufficientRoomsForDiscount) {
      return 'Your workplace qualifies for up to 35% off.';
    } else {
      return 'Customers who buy more than 10 rooms could qualify for up to 35% off.';
    }
  }

  constructor() {
    super(...arguments);
    this.trackView.perform();
  }

  trackView = task(async () => {
    await this.metrics.trackEvent('Viewed flash message', {
      product: 'rooms',
      type: 'info',
      message_title: `${this.args.response.title} ${this.message}`,
      message_code: 'rooms_discount_message_viewed',
      message_code_type: 'rooms_discount_message',
    });
  });

  createSalesforceLead = dropTask(async () => {
    try {
      await this.salesforceLeads.createLead({
        email: this.currentAdmin.email,
        name: this.currentAdmin.fullName,
        leadSource: 'Billing Page - Rooms Custom Pricing Alert',
      });

      this.flashMessages.showAndHideFlash('success', 'Request Sent', "We'll be reaching out soon!");
    } catch (error) {
      this.flashMessages.showFlash('error', 'Try again', parseErrorForDisplay(error));
      throw error;
    }
  });
}
